/*
  ltt-buy-now — the product page's "Buy it now" (Hamdi 2026-08-19c).

  Replaces Shopify's `form | payment_button`, which on an iPhone renders an
  Apple Pay button plus a "More payment options" link. Apple Pay is still
  offered at checkout, so removing it here costs the shopper nothing.

  🔴 THE IMPORTANT PART: this does NOT add to cart itself. It clicks the real
  Add-to-cart button and, when the cart confirms, sends the shopper to
  /checkout.

  Why that indirection instead of POSTing /cart/add.js directly:
    • `bridal-box` carries FIVE REQUIRED option groups that belong to the Globo
      app, not to Shopify variants. Globo enforces them by hooking the normal
      submit. A bespoke POST would bypass that and quietly take an order with
      no options at the base price — the exact bug that was caught in the quick
      view in August.
    • Whatever validation, error rendering and cart behaviour Add-to-cart has,
      Buy-it-now inherits for free and cannot drift from it.

  On failure nothing happens here: product-form.js renders its own error and no
  cartUpdate fires, so we never navigate.
*/
(function () {
  var pending = false;
  /* Globo's own flow does a FULL PAGE NAVIGATION to /cart for products that
     carry its option groups, so the in-page cartUpdate below never fires and
     the redirect is lost — measured on bridal-box, which landed on /cart with
     a correct 2485 EGP line. A short-lived flag carries the intent across that
     navigation. Deliberately narrow: only honoured when we land on /cart, only
     within the window, only with a non-empty cart, and consumed on first read. */
  var HANDOFF = 'ltt-buy-now-pending';
  var HANDOFF_MS = 12000;

  function submitFor(trigger) {
    var id = trigger.getAttribute('data-ltt-buy-now-for');
    var form = trigger.closest('product-form') || document;
    return (id && document.getElementById(id)) || form.querySelector('.product-form__submit');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ltt-buy-now]');
    if (!trigger || trigger.disabled) return;
    event.preventDefault();
    var submit = submitFor(trigger);
    if (!submit || submit.disabled) return;
    pending = true;
    trigger.classList.add('is-loading');
    try { sessionStorage.setItem(HANDOFF, String(Date.now())); } catch (e) {}
    submit.click();
    /* If the add never lands (validation blocked it, network died), release the
       button so she can try again instead of staring at a dead control. */
    setTimeout(function () {
      if (!pending) return;
      pending = false;
      trigger.classList.remove('is-loading');
    }, 8000);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!pending) return;
      if (data && data.source && data.source !== 'product-form') return;
      pending = false;
      try { sessionStorage.removeItem(HANDOFF); } catch (e) {}
      /* Buy-it-now is the one path to checkout that never passes through a cart
         surface, so the Buy-3-Get-1 cap notice would never get a chance to stop
         it. Defer one tick: product-form.js publishes cartUpdate and only THEN
         calls renderContents(), so the fresh verdict is not in the DOM yet when
         this subscriber runs.
         🪤 setTimeout, not requestAnimationFrame — rAF is part of the rendering
         cycle and does not fire in a hidden tab. */
      setTimeout(function () {
        if (window.lttCartCapBlocked && window.lttCartCapBlocked()) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          return;
        }
        window.location.href = checkoutUrl();
      }, 0);
    });
  }

  function checkoutUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'checkout';
  }

  /* The other half of the Globo hand-off: we have just landed somewhere. */
  function resumeAfterNavigation() {
    var stamp;
    try {
      stamp = sessionStorage.getItem(HANDOFF);
      sessionStorage.removeItem(HANDOFF);   // consume once, whatever happens
    } catch (e) {
      return;
    }
    if (!stamp) return;
    if (Date.now() - Number(stamp) > HANDOFF_MS) return;
    /* Only /cart — that is where Globo sends her. Anywhere else and this was
       not the hand-off we are waiting for. */
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (window.location.pathname.replace(/\/$/, '') !== (root + 'cart').replace(/\/$/, '')) return;
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        /* Same guard as above. This one landed on /cart, where the notice is
           already painted, so it can read the flag without deferring. */
        if (window.lttCartCapBlocked && window.lttCartCapBlocked()) return;
        window.location.href = checkoutUrl();
      })
      .catch(function () {});
  }

  /* Keep Buy-it-now's disabled state in step with Add-to-cart. product-info.js
     toggles the submit button on every variant change and knows nothing about
     this one, so it is mirrored rather than computed twice. */
  function mirror() {
    document.querySelectorAll('[data-ltt-buy-now]').forEach(function (trigger) {
      var submit = submitFor(trigger);
      if (!submit) return;
      trigger.disabled = submit.disabled;
      new MutationObserver(function () {
        trigger.disabled = submit.disabled;
      }).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
    });
  }

  function init() {
    resumeAfterNavigation();
    mirror();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
